import { motion } from "framer-motion";
import { FiSearch } from "react-icons/fi";
import styled from "styled-components";

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 4rem;
  width: 100%;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const PageTitle = styled.h1`
  color: #ff6b35;
  font-size: 3rem;
  line-height: 3rem;
  margin-bottom: 1rem;
  font-weight: bold;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const PageSubtitle = styled.p`
  color: #cccccc;
  font-size: 1.2rem;
  max-width: 650px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const ControlsSection = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
`;

export const SearchInput = styled.input`
  background: #2c2c2c;
  color: #fff;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 0.8rem 2.5rem 0.8rem 1rem;
  width: 100%;
  font-size: 1rem;

  &::placeholder {
    color: #aaa;
  }

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;

export const SearchIcon = styled(FiSearch)`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #ff6b35;
`;

export const FilterTabs = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const FilterTab = styled.button`
  background: ${({ $active }) => ($active ? "#ff6b35" : "#2c2c2c")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#cccccc")};
  border: 1px solid ${({ $active }) => ($active ? "#ff6b35" : "#333")};
  padding: 0.6rem 1.2rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: ${({ $active }) => ($active ? "bold" : "normal")};
  font-size: 0.9rem;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    border-color: #ff6b35;
  }
`;

export const NewsGrid = styled.div`
  column-width: 400px;
  column-gap: 2rem;
  column-fill: balance;
  margin-bottom: 2rem;

  @media (max-width: 1200px) {
    column-width: 350px;
    column-gap: 1.5rem;
  }

  @media (max-width: 768px) {
    column-width: 300px;
    column-gap: 1rem;
  }

  @media (max-width: 480px) {
    column-width: 100%;
    column-count: 1;
  }
`;

export const NewsCard = styled(motion.article)`
  background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);

  border-radius: 15px;
  overflow: hidden;
  border: 1px solid #333;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  height: fit-content;
  margin-bottom: 2rem;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(255, 107, 53, 0.2);
    border-color: #ff6b35;
  }
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

export const NewsImage = styled.div`
  height: 300px;
  background: ${({ $backgroundImage }) =>
    $backgroundImage
      ? `linear-gradient(
          135deg, 
          rgba(26, 26, 26, 0.2) 0%, 
          rgba(42, 42, 42, 0.25) 50%,
          rgba(26, 26, 26, 0.2) 100%
        ), 
        url(${$backgroundImage})`
      : "linear-gradient(45deg, #333, #555, #ff6b35)"};

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 107, 53, 0.3),
      rgba(0, 0, 0, 0.6)
    );
  }
`;

export const NewsDate = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(255, 107, 53, 0.95);
  color: #ffffff;
  padding: 0.5rem 0.8rem;
  border-radius: 8px;
  font-weight: bold;
  z-index: 3;
  font-size: 0.8rem;
`;

export const NewsType = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: ${({ type }) =>
    type === "concert"
      ? "#27ae60"
      : type === "album"
      ? "#9b59b6"
      : type === "interview"
      ? "#3498db"
      : type === "video"
      ? "#e74c3c"
      : type === "award"
      ? "#f39c12"
      : "#ff6b35"};
  color: #ffffff;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 3;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const NewsContent = styled.div`
  padding: 1.5rem;
`;

export const BandTag = styled.span`
  background: #ff6b35;
  color: #ffffff;
  padding: 0.2rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 0.8rem;
`;

export const NewsTitle = styled.h2`
  color: #ffffff;
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
  font-weight: bold;
  line-height: 1.3;
`;

export const NewsExcerpt = styled.p`
  color: #cccccc;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const NewsLocation = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #aaa;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;

  svg {
    color: #ff6b35;
  }
`;

export const NewsTime = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #aaa;
  margin-bottom: 1rem;
  font-size: 0.9rem;

  svg {
    color: #ff6b35;
  }
`;

export const NewsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid #333;
`;

export const NewsActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ActionBtn = styled.button`
  background: ${({ $primary }) => ($primary ? "#ff6b35" : "transparent")};
  color: ${({ $primary }) => ($primary ? "#ffffff" : "#ff6b35")};
  border: 2px solid #ff6b35;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: bold;
  font-size: 0.9rem;

  &:hover {
    background: #ff6b35;
    color: #ffffff;
    transform: translateY(-1px);
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: #cccccc;
  min-height: 500px;
  margin-bottom: 2rem;

  h3 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  p {
    font-size: 1.1rem;
  }
`;

// POBOLJŠANA FEATURED SEKCIJA
export const FeaturedSection = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 50%, #1a1a1a 100%);
  border-radius: 20px;
  padding: 0;
  margin-bottom: 3rem;
  color: #ffffff;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid #333;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 40px rgba(255, 107, 53, 0.15);
    border-color: #ff6b35;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(255, 107, 53, 0.1) 0%,
      transparent 50%,
      rgba(255, 107, 53, 0.1) 100%
    );
    z-index: 1;
  }

  @media (max-width: 768px) {
    border-radius: 15px;
    margin-bottom: 2rem;
  }
`;

export const FeaturedContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  min-height: 300px;
  position: relative;
  z-index: 2;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FeaturedImageSection = styled.div`
  position: relative;

  background: ${({ $backgroundImage }) =>
    $backgroundImage
      ? `linear-gradient(
          135deg, 
          rgba(26, 26, 26, 0.2) 0%, 
          rgba(42, 42, 42, 0.25) 50%,
          rgba(26, 26, 26, 0.2) 100%
        ), 
        url(${$backgroundImage})`
      : "linear-gradient(45deg, #ff6b35, #ff8c42, #ffb74d)"};

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  border-radius: 20px 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-height: 300px;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(255, 107, 53, 0.1) 50%,
      rgba(0, 0, 0, 0.3) 100%
    );
  }

  @media (max-width: 968px) {
    border-radius: 20px 20px 0 0;
    min-height: 200px;
  }
`;

export const FeaturedIcon = styled.div`
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.9);
  z-index: 3;
  position: relative;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
`;

export const FeaturedTextContent = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const FeaturedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 107, 53, 0.15);
  color: #ff6b35;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 1rem;
  width: fit-content;
  border: 1px solid rgba(255, 107, 53, 0.3);
`;

export const FeaturedTitle = styled.h2`
  font-size: 2.2rem;
  margin-bottom: 1rem;
  font-weight: bold;
  line-height: 1.2;
  background: linear-gradient(135deg, #ffffff, #cccccc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const FeaturedBandName = styled.div`
  color: #ff6b35;
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const FeaturedText = styled.p`
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
  color: #cccccc;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
`;

export const FeaturedMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const FeaturedMetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #aaa;
  font-size: 0.9rem;

  svg {
    color: #ff6b35;
  }
`;

export const FeaturedActions = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const FeaturedActionBtn = styled.button`
  background: ${({ $primary }) =>
    $primary
      ? "linear-gradient(135deg, #ff6b35, #ff8c42)"
      : "rgba(255, 107, 53, 0.1)"};
  color: #ffffff;
  border: 2px solid
    ${({ $primary }) => ($primary ? "#ff6b35" : "rgba(255, 107, 53, 0.3)")};
  padding: 0.8rem 1.5rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: bold;
  font-size: 0.95rem;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
    border-color: #ff6b35;
    background: linear-gradient(135deg, #ff6b35, #ff8c42);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }
`;
